import type { IconType } from "@circle-react-shared/Icon";
import { Icon } from "@circle-react-shared/Icon";

export interface RadioButtonIconProps {
  hasRadioCheckmarks?: boolean;
  isChecked: boolean;
  radioCheckmarksCheckedIcon?: IconType;
  radioCheckmarksUncheckedIcon?: IconType;
}

export const RadioButtonIcon = ({
  isChecked = false,
  hasRadioCheckmarks = false,
  radioCheckmarksCheckedIcon = "24-radio-checked",
  radioCheckmarksUncheckedIcon = "24-radio-unchecked",
}: RadioButtonIconProps) => {
  if (hasRadioCheckmarks) {
    return isChecked ? (
      <span className="text-selector-active flex">
        <Icon size={24} type={radioCheckmarksCheckedIcon} />
      </span>
    ) : (
      <span className="text-lightest flex">
        <Icon size={24} type={radioCheckmarksUncheckedIcon} />
      </span>
    );
  }

  if (isChecked) {
    return (
      <span className="text-selector-active flex">
        <Icon size={16} type="16-check-circle" />
      </span>
    );
  }

  return null;
};
